import React from "react";
import { Link } from "react-router-dom";

const ProjectBox = ({ projectInfo = {}, i }) => {
  const { img = "", desc = "", name = "" } = projectInfo;
  // Collapse line breaks/indentation from multi-line descriptions before trimming
  const summary = desc.replace(/\s+/g, " ").trim();
  return (
    <div className="project-box">
      <img src={img} alt={name} loading="lazy" />
      <div className="project-box-body">
        <h2>{name}</h2>
        <p>{summary.length > 75 ? summary.slice(0, 75) + ". . . " : summary}</p>
        <Link to={`/projects/${i}`} className="jbutton">
          View details
        </Link>
      </div>
    </div>
  );
};

export default ProjectBox;
